"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const lodash_1 = __importDefault(require("lodash"));
const react_dom_1 = __importDefault(require("react-dom"));
require("./styles/chart.scss");
const constants_1 = require("./constants");
const chart_helpers_1 = require("./util/chart.helpers");
const LineChart_1 = __importDefault(require("./components/LineChart"));
const LineChart_2 = __importDefault(require("./components/ReactMigration/LineChart"));
const LineChart_3 = __importDefault(require("./components/React/LineChart"));
const Map_1 = __importDefault(require("./components/Map"));
const Map_2 = __importDefault(require("./components/ReactMigration/Map"));
const Map_3 = __importDefault(require("./components/React/Map"));
const TimeSeriesBarChart_1 = __importDefault(require("./components/React/TimeSeriesBarChart"));
const Cartogram_1 = __importDefault(require("./components/React/Cartogram"));
const DotPlot_1 = __importDefault(require("./components/DotPlot"));
const DotPlot_2 = __importDefault(require("./components/ReactMigration/DotPlot"));
const DotPlot_3 = __importDefault(require("./components/React/DotPlot"));
const BarChart_1 = __importDefault(require("./components/BarChart"));
const BarChart_2 = __importDefault(require("./components/ReactMigration/BarChart"));
const BarChart_3 = __importDefault(require("./components/React/BarChart"));
const SmallMultiples_1 = __importDefault(require("./components/SmallMultiples"));
const BubbleChart_1 = __importDefault(require("./components/BubbleChart"));
const SankeyDiagram_1 = __importDefault(require("./components/SankeyDiagram"));
const IncomeDistribution_1 = __importDefault(require("./components/IncomeDistribution"));
const TimeBarChart_1 = __importDefault(require("./components/TimeBarChart"));
const Beeswarm_1 = __importDefault(require("./components/Beeswarm"));
const MosaicPlot_1 = __importDefault(require("./components/MosaicPlot"));
const SankeyVertical_1 = __importDefault(require("./components/SankeyVertical"));
const SOTU2021Education_1 = __importDefault(require("./components/SOTU2021Education"));
const GroupedBar_1 = __importDefault(require("./components/GroupedBar"));
const usafacts_icon_gif_1 = __importDefault(require("./assets/usafacts-icon.gif"));
const ChartModel_1 = require("./ChartModel");
const removeCurrentChartClass = (selection, chartType) => {
  selection.classed(lodash_1.default.kebabCase(lodash_1.default.findKey(constants_1.CHART_TYPES, type => type === chartType)), false);
};
class Chart {
  constructor(container) {
    if (container === undefined) {
      return;
    }
    this.container = (0, chart_helpers_1.getD3Selection)(container);
    if (this.container === null) {
      throw new Error('[Chart] Constructor argument is not an Element or D3 selection, or two instances of D3 are being used');
    }
    this.container.classed('dh-chart-wrapper', true);
    this.chart = null;
    this.initLoading();
  }
  async draw(data) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const {
      chartType
    } = options;
    const chartTypeId = (0, ChartModel_1.getChartTypeID)(chartType, data);
    if (!this.chart || this.chart.chartType !== chartTypeId) {
      if (this.chart) {
        removeCurrentChartClass(this.container, this.chart.chartType);
        if (this.chart.ro) this.chart.ro.disconnect();
      }
      try {
        // This is dumb
        react_dom_1.default.unmountComponentAtNode(this.container.node());
      } catch (e) {
        /**
         * We're doing nothing because this error is likely "cannot unmount what is not mounted",
         * which present a message like:
         * Warning: unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. Instead, have the parent component update its state and rerender in order to remove this component.
         */
      }
      this.container.selectAll('*').remove();
      this.chart = this.createChart(chartTypeId);
      this.initLoading();
    }
    this.container.select('.chart-error').style('display', null);
    this.setLoading();
    if (await this.chart.draw(data, options)) {
      this.container.select(`.${this.chart.cssPrefix}`).style('visibility', null);
    }
    this.container.select('.chart-loading').style('display', null);
  }
  // eslint-disable-next-line default-param-last
  async drawCanvas(dataPromises, options) {
    let canvasOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let canvas = arguments.length > 3 ? arguments[3] : undefined;
    const {
      chartType
    } = options;
    const chartTypeId = (0, ChartModel_1.getChartTypeID)(chartType, dataPromises);
    if (!this.chart || this.chart.chartType !== chartTypeId) {
      this.chart = this.createChart(chartTypeId);
    }
    if (this.chart.drawCanvas === undefined) {
      console.error(`Cannot draw chart type ${chartTypeId} to canvas.`);
      return canvas;
    }
    return this.chart.drawCanvas(dataPromises, options, canvasOptions, canvas);
  }
  initLoading() {
    this.container.append('div').classed('chart-loading', true).append('img').attr('src', usafacts_icon_gif_1.default);
  }
  setLoading() {
    this.container.select('.chart-loading').style('display', 'flex');
  }
  createChart(chartTypeID) {
    switch (chartTypeID) {
      case constants_1.CHART_TYPES.LineChart:
        return new LineChart_1.default(this.container);
      case constants_1.CHART_TYPES.LineChartReactMigration:
        return new LineChart_2.default(this.container);
      case constants_1.CHART_TYPES.LineChartReact:
        return new LineChart_3.default(this.container);
      case constants_1.CHART_TYPES.Map:
        return new Map_1.default(this.container);
      case constants_1.CHART_TYPES.MapReactMigration:
        return new Map_2.default(this.container);
      case constants_1.CHART_TYPES.MapReact:
        return new Map_3.default(this.container);
      case constants_1.CHART_TYPES.TimeSeriesBarChart:
        return new TimeSeriesBarChart_1.default(this.container);
      case constants_1.CHART_TYPES.CartogramReact:
        return new Cartogram_1.default(this.container);
      case constants_1.CHART_TYPES.DotPlot:
        return new DotPlot_1.default(this.container);
      case constants_1.CHART_TYPES.DotPlotReactMigration:
        return new DotPlot_2.default(this.container);
      case constants_1.CHART_TYPES.DotPlotReact:
        return new DotPlot_3.default(this.container);
      case constants_1.CHART_TYPES.BarChart:
        return new BarChart_1.default(this.container);
      case constants_1.CHART_TYPES.BarChartReactMigration:
        return new BarChart_2.default(this.container);
      case constants_1.CHART_TYPES.BarChartReact:
        return new BarChart_3.default(this.container);
      case constants_1.CHART_TYPES.SmallMultiples:
        return new SmallMultiples_1.default(this.container);
      case constants_1.CHART_TYPES.BubbleChart:
        return new BubbleChart_1.default(this.container);
      case constants_1.CHART_TYPES.Sankey:
        return new SankeyDiagram_1.default(this.container);
      case constants_1.CHART_TYPES.IncomeDistribution:
        return new IncomeDistribution_1.default(this.container);
      case constants_1.CHART_TYPES.TimeBarChart:
        return new TimeBarChart_1.default(this.container);
      case constants_1.CHART_TYPES.Beeswarm:
        return new Beeswarm_1.default(this.container);
      case constants_1.CHART_TYPES.MosaicPlot:
        return new MosaicPlot_1.default(this.container);
      case constants_1.CHART_TYPES.SankeyVertical:
        return new SankeyVertical_1.default(this.container);
      case constants_1.CHART_TYPES.SOTU2021Education:
        return new SOTU2021Education_1.default(this.container);
      case constants_1.CHART_TYPES.GroupedBars:
        return new GroupedBar_1.default(this.container);
      default:
        return null;
    }
  }
}
exports.default = Chart;